<template>
  <v-container id="company" fluid>
    <v-row align="center" justify="center">
			<v-col cols="12">	
				<v-data-table :headers="headers" :items="companies" :options.sync="options" :loading="loading" loading-text="Loading Companies..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true, firstIcon: 'first_page', lastIcon: 'last_page', prevIcon: 'navigate_before', nextIcon: 'navigate_next'}" class="elevation-1">
         			<template v-slot:top>	
						<v-row>	
							<v-col>				
								<v-btn @click.prevent="openAddCompanyDialog()" small color="primary">Add Company</v-btn>	
							</v-col>									
						</v-row>						
						<v-divider />
					</template>
					<template v-slot:item.license="{ item }">
						<v-icon small @click.prevent="openLicensesCompanyDialog(item)">article</v-icon>					
					</template>
					<template v-slot:item.users="{ item }">
						<v-icon small @click.prevent="openUsersCompanyDialog(item)">group</v-icon>					
					</template>
				    <template v-slot:item.actions="{ item }">
						<v-icon small @click.prevent="openEditCompanyDialog(item)">edit</v-icon>
						<v-icon small @click.prevent="openDeleteCompanyDialog(item)">delete</v-icon>
					</template>
				</v-data-table>		
        		<v-dialog v-model="deleteCompanyDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Delete Company</span>
						</v-card-title>
						<v-card-text>
							<v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
							<v-container>
								 <v-row> 
                                    <v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
                                </v-row>
								<v-row>
									<v-col cols="12">
										<span>The company will be permanently removed!</span>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeDeleteCompanyDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="deleteCompanies()">Delete</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>    			
        		<v-dialog v-model="editCompanyDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Edit Company</span>
						</v-card-title>
						<v-card-text>
							<v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
							<v-form ref="editDialogFormCompany">
								<v-container>
									<v-row>
										<v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
									</v-row>
									<v-row>
										<v-col cols="12">
											<v-text-field v-model="editedModelCompany.name" :rules="[...getRlDialogRules.required]" label="Name" type="text" autocomplete="off" />
										</v-col>							
									</v-row>
								</v-container>
							</v-form>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeEditCompanyDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="updateCompany()">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>	
         		<v-dialog v-model="addCompanyDialog" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Add Company</span>
						</v-card-title>
						<v-card-text>
							<v-progress-linear :active="isLoadingDialog" height="3" indeterminate absolute color="primary" />
							<v-form ref="addDialogFormCompany">
								<v-container>
									<v-row >
										<v-alert dense outlined :value="alert.isAlert" color="error" >{{ alert.alertMessage }}</v-alert>
									</v-row>
									<v-row>
										<v-col cols="12">
											<v-text-field v-model="editedModelCompany.name" :rules="[...getRlDialogRules.required]" label="Name" type="text" autocomplete="off" />
										</v-col>							
									</v-row>
								</v-container>
							 </v-form>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="closeAddCompanyDialog()">Close</v-btn>
							<v-btn color="primary" @click.prevent="addCompanies()">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<CompanyLicenses :licenses-company-dialog="licensesCompanyDialog" v-if="licensesCompanyDialog" v-on:closeLicensesCompanyDialog = "() => closeLicensesCompanyDialog()" :id-company="currentCompanyId" />	
			</v-col>
		</v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex'

import CompanyLicenses from "../components/CompanyLicenses.vue";

export default {
	name: 'Company',
	components: {
		CompanyLicenses: CompanyLicenses,
	},
    data() {
		return {
		headers: [			
			{ text: 'Id', value: 'id' },
			{ text: 'Name', value: 'name' },	
			{ text: 'License', value: 'license' },
			{ text: 'Users', value: 'users' },
			{ text: 'Actions', value: 'actions', sortable: false },			
		],
		isLoadingDialog: false,
		alert: {isAlert: false, alertMessage: ''},  
		options: {},
		companies: [],
		loading: true,   
		licensesCompanyDialog: false,  
		addCompanyDialog: false,
		editCompanyDialog: false,
		deleteCompanyDialog: false,
		currentCompanyId: null,
		modelCompany:{
			id: null,
			name:'',
		},     
		editedModelCompany: {
			id: null,
			name: '',
		}
		}
 	},
    mounted() {
	  this.$store.dispatch('setRoleList');
	},
    watch: {
		options: {
			handler() {
				this.getCompanies()
			}
		},
		deep: true
	},
    methods: {
		openLicensesCompanyDialog(item) {
			this.currentCompanyId = item.id
			this.licensesCompanyDialog = true;
		},
		openAddCompanyDialog() {
			this.addCompanyDialog = true;
		},
		openEditCompanyDialog(item) {			
			this.editedModelCompany = Object.assign({}, item)
			this.editCompanyDialog = true
		},    
		openDeleteCompanyDialog(item) {     
			this.currentCompanyId =item.id
			this.deleteCompanyDialog = true
		},
		closeLicensesCompanyDialog() {
			this.licensesCompanyDialog = false;	
		},
		openUsersCompanyDialog() {

		},
		closeEditCompanyDialog() {
			this.editCompanyDialog = false;
			this.editedModelCompany = {...this.modelCompany}
			this.alert = {isAlert: false, alertMessage: ''}   
		},
		closeAddCompanyDialog() {
			this.addCompanyDialog = false;      
			this.editedModelCompany = {...this.modelCompany}
			this.alert = {isAlert: false, alertMessage: ''}   
		},
		closeDeleteCompanyDialog() {
			this.deleteCompanyDialog = false;
			this.alert = {isAlert: false, alertMessage: ''}   
		},
		async updateCompany() {		
			if (this.$refs.editDialogFormCompany.validate()) {
				try{
					this.isLoadingDialog = true					
					await axios.put('api/v1/companies/' + this.editedModelCompany.id, JSON.stringify(this.editedModelCompany))
					this.editedModelCompany = {...this.modelCompany}
					this.editCompanyDialog = false;
					this.isLoadingDialog = false
					await this.getCompanies()
				}catch(err){
					this.isLoadingDialog = false
					this.alert = {isAlert: true, alertMessage: err}      
				}
			}
		},
		async deleteCompanies() {
			try{      
				this.isLoadingDialog = true
				await axios.delete('api/v1/companies/'+this.currentCompanyId)
				this.deleteCompanyDialog = false;
				this.isLoadingDialog = false
				await this.getCompanies()
			}catch(err){
				this.isLoadingDialog = false
				this.alert = {isAlert: true, alertMessage: err}      
			}
		},
		async addCompanies() {
			if (this.$refs.addDialogFormCompany.validate()) {
				try{
					this.isLoadingDialog = true
					await axios.post('api/v1/companies', JSON.stringify(this.editedModelCompany))
					this.editedModelCompany = {...this.modelCompany}
					this.addCompanyDialog = false;
					this.isLoadingDialog = false
					await this.getCompanies()
				}catch(err){
					this.isLoadingDialog = false
					this.alert = {isAlert: true, alertMessage: err.message}      
				}
			}
		},
		async getCompanies() {		    
			try {
				this.loading = true  
				const response = await axios.get('api/v1/companies')     	
				this.companies = await JSON.parse(JSON.stringify(response.data.data)) 
				this.loading = false		  	
			} catch (error) {
				this.loading = false	
			}				
		},
    },
  computed: {
         ...mapGetters([    
            'getRlDialogRules',
        ])
    }    
}
</script>
